// import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_frontend.js'; import './autoload/_visitor_language_popup.js' // eslint-disable-line

// import react habitat and react components
import './init/react'

// import styles from blocks

import '../gutenberg/blocks/accordion-item/styles.scss'; import '../gutenberg/blocks/accordion/styles.scss'; import '../gutenberg/blocks/button/styles.scss'; import '../gutenberg/blocks/buttons/styles.scss'; import '../gutenberg/blocks/download-links/styles.scss' // eslint-disable-line

//frontend blocks
import '../gutenberg/blocks/accordion/functions'

import './init/localization'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

import { onDocumentReady } from './util/events'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
onDocumentReady(() => routes.loadEvents())
